export enum GlobalizationSettingsKeys {
    DateFormat = 'DATE_FORMAT',
    TimeZone = 'TIME_ZONE',
    CurrencyCode = 'CURRENCY_CODE',
    ThousandSeparator = 'THOUSANDS_SEPERATOR',
}
